const state = {
    popup_open: false,
    popup_name: '',
    popup_data: false,
};

const mutations = {
    togglePopup(state, payload) {
        if (typeof payload !== 'undefined' && typeof payload.name !== 'undefined') {
            state.popup_name = payload.name;
            state.popup_open = true;

            if (typeof payload.data !== 'undefined') {
                state.popup_data = payload.data;
            }
        } else {
            state.popup_name = '';
            state.popup_open = false;
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
}